export const COUNTRIES = [
  {
    id: 'france',
    value: 'france',
    label: 'France',
  },
  {
    id: 'afghanistan',
    value: 'afghanistan',
    label: 'Afghanistan',
  },
  {
    id: 'aland islands',
    value: 'aland islands',
    label: 'Aland Islands',
  },
  {
    id: 'albania',
    value: 'albania',
    label: 'Albania',
  },
  {
    id: 'algeria',
    value: 'algeria',
    label: 'Algeria',
  },
  {
    id: 'american samoa',
    value: 'american samoa',
    label: 'American Samoa',
  },
  {
    id: 'andorra',
    value: 'andorra',
    label: 'Andorra',
  },
  {
    id: 'angola',
    value: 'angola',
    label: 'Angola',
  },
  {
    id: 'anguilla',
    value: 'anguilla',
    label: 'Anguilla',
  },
  {
    id: 'antarctica',
    value: 'antarctica',
    label: 'Antarctica',
  },
  {
    id: 'antigua and barbuda',
    value: 'antigua and barbuda',
    label: 'Antigua and Barbuda',
  },
  {
    id: 'argentina',
    value: 'argentina',
    label: 'Argentina',
  },
  {
    id: 'armenia',
    value: 'armenia',
    label: 'Armenia',
  },
  {
    id: 'aruba',
    value: 'aruba',
    label: 'Aruba',
  },
  {
    id: 'australia',
    value: 'australia',
    label: 'Australia',
  },
  {
    id: 'austria',
    value: 'austria',
    label: 'Austria',
  },
  {
    id: 'azerbaijan',
    value: 'azerbaijan',
    label: 'Azerbaijan',
  },
  {
    id: 'bahamas',
    value: 'bahamas',
    label: 'Bahamas',
  },
  {
    id: 'bahrain',
    value: 'bahrain',
    label: 'Bahrain',
  },
  {
    id: 'bangladesh',
    value: 'bangladesh',
    label: 'Bangladesh',
  },
  {
    id: 'barbados',
    value: 'barbados',
    label: 'Barbados',
  },
  {
    id: 'belarus',
    value: 'belarus',
    label: 'Belarus',
  },
  {
    id: 'belgium',
    value: 'belgium',
    label: 'Belgium',
  },
  {
    id: 'belize',
    value: 'belize',
    label: 'Belize',
  },
  {
    id: 'benin',
    value: 'benin',
    label: 'Benin',
  },
  {
    id: 'bermuda',
    value: 'bermuda',
    label: 'Bermuda',
  },
  {
    id: 'bhutan',
    value: 'bhutan',
    label: 'Bhutan',
  },
  {
    id: 'bolivia',
    value: 'bolivia',
    label: 'Bolivia',
  },
  {
    id: 'bonaire, saint eustatius and saba ',
    value: 'bonaire, saint eustatius and saba ',
    label: 'Bonaire, Saint Eustatius and Saba ',
  },
  {
    id: 'bosnia and herzegovina',
    value: 'bosnia and herzegovina',
    label: 'Bosnia and Herzegovina',
  },
  {
    id: 'botswana',
    value: 'botswana',
    label: 'Botswana',
  },
  {
    id: 'bouvet island',
    value: 'bouvet island',
    label: 'Bouvet Island',
  },
  {
    id: 'brazil',
    value: 'brazil',
    label: 'Brazil',
  },
  {
    id: 'british indian ocean territory',
    value: 'british indian ocean territory',
    label: 'British Indian Ocean Territory',
  },
  {
    id: 'british virgin islands',
    value: 'british virgin islands',
    label: 'British Virgin Islands',
  },
  {
    id: 'brunei',
    value: 'brunei',
    label: 'Brunei',
  },
  {
    id: 'bulgaria',
    value: 'bulgaria',
    label: 'Bulgaria',
  },
  {
    id: 'burkina faso',
    value: 'burkina faso',
    label: 'Burkina Faso',
  },
  {
    id: 'burundi',
    value: 'burundi',
    label: 'Burundi',
  },
  {
    id: 'cambodia',
    value: 'cambodia',
    label: 'Cambodia',
  },
  {
    id: 'cameroon',
    value: 'cameroon',
    label: 'Cameroon',
  },
  {
    id: 'canada',
    value: 'canada',
    label: 'Canada',
  },
  {
    id: 'cape verde',
    value: 'cape verde',
    label: 'Cape Verde',
  },
  {
    id: 'cayman islands',
    value: 'cayman islands',
    label: 'Cayman Islands',
  },
  {
    id: 'central african republic',
    value: 'central african republic',
    label: 'Central African Republic',
  },
  {
    id: 'chad',
    value: 'chad',
    label: 'Chad',
  },
  {
    id: 'chile',
    value: 'chile',
    label: 'Chile',
  },
  {
    id: 'china',
    value: 'china',
    label: 'China',
  },
  {
    id: 'christmas island',
    value: 'christmas island',
    label: 'Christmas Island',
  },
  {
    id: 'cocos islands',
    value: 'cocos islands',
    label: 'Cocos Islands',
  },
  {
    id: 'colombia',
    value: 'colombia',
    label: 'Colombia',
  },
  {
    id: 'comoros',
    value: 'comoros',
    label: 'Comoros',
  },
  {
    id: 'cook islands',
    value: 'cook islands',
    label: 'Cook Islands',
  },
  {
    id: 'costa rica',
    value: 'costa rica',
    label: 'Costa Rica',
  },
  {
    id: 'croatia',
    value: 'croatia',
    label: 'Croatia',
  },
  {
    id: 'cuba',
    value: 'cuba',
    label: 'Cuba',
  },
  {
    id: 'curacao',
    value: 'curacao',
    label: 'Curacao',
  },
  {
    id: 'cyprus',
    value: 'cyprus',
    label: 'Cyprus',
  },
  {
    id: 'czech republic',
    value: 'czech republic',
    label: 'Czech Republic',
  },
  {
    id: 'democratic republic of the congo',
    value: 'democratic republic of the congo',
    label: 'Democratic Republic of the Congo',
  },
  {
    id: 'denmark',
    value: 'denmark',
    label: 'Denmark',
  },
  {
    id: 'djibouti',
    value: 'djibouti',
    label: 'Djibouti',
  },
  {
    id: 'dominica',
    value: 'dominica',
    label: 'Dominica',
  },
  {
    id: 'dominican republic',
    value: 'dominican republic',
    label: 'Dominican Republic',
  },
  {
    id: 'east timor',
    value: 'east timor',
    label: 'East Timor',
  },
  {
    id: 'ecuador',
    value: 'ecuador',
    label: 'Ecuador',
  },
  {
    id: 'egypt',
    value: 'egypt',
    label: 'Egypt',
  },
  {
    id: 'el salvador',
    value: 'el salvador',
    label: 'El Salvador',
  },
  {
    id: 'equatorial guinea',
    value: 'equatorial guinea',
    label: 'Equatorial Guinea',
  },
  {
    id: 'eritrea',
    value: 'eritrea',
    label: 'Eritrea',
  },
  {
    id: 'estonia',
    value: 'estonia',
    label: 'Estonia',
  },
  {
    id: 'ethiopia',
    value: 'ethiopia',
    label: 'Ethiopia',
  },
  {
    id: 'falkland islands',
    value: 'falkland islands',
    label: 'Falkland Islands',
  },
  {
    id: 'faroe islands',
    value: 'faroe islands',
    label: 'Faroe Islands',
  },
  {
    id: 'fiji',
    value: 'fiji',
    label: 'Fiji',
  },
  {
    id: 'finland',
    value: 'finland',
    label: 'Finland',
  },
  {
    id: 'french guiana',
    value: 'french guiana',
    label: 'French Guiana',
  },
  {
    id: 'french polynesia',
    value: 'french polynesia',
    label: 'French Polynesia',
  },
  {
    id: 'french southern territories',
    value: 'french southern territories',
    label: 'French Southern Territories',
  },
  {
    id: 'gabon',
    value: 'gabon',
    label: 'Gabon',
  },
  {
    id: 'gambia',
    value: 'gambia',
    label: 'Gambia',
  },
  {
    id: 'georgia',
    value: 'georgia',
    label: 'Georgia',
  },
  {
    id: 'germany',
    value: 'germany',
    label: 'Germany',
  },
  {
    id: 'ghana',
    value: 'ghana',
    label: 'Ghana',
  },
  {
    id: 'gibraltar',
    value: 'gibraltar',
    label: 'Gibraltar',
  },
  {
    id: 'greece',
    value: 'greece',
    label: 'Greece',
  },
  {
    id: 'greenland',
    value: 'greenland',
    label: 'Greenland',
  },
  {
    id: 'grenada',
    value: 'grenada',
    label: 'Grenada',
  },
  {
    id: 'guadeloupe',
    value: 'guadeloupe',
    label: 'Guadeloupe',
  },
  {
    id: 'guam',
    value: 'guam',
    label: 'Guam',
  },
  {
    id: 'guatemala',
    value: 'guatemala',
    label: 'Guatemala',
  },
  {
    id: 'guernsey',
    value: 'guernsey',
    label: 'Guernsey',
  },
  {
    id: 'guinea',
    value: 'guinea',
    label: 'Guinea',
  },
  {
    id: 'guinea-bissau',
    value: 'guinea-bissau',
    label: 'Guinea-Bissau',
  },
  {
    id: 'guyana',
    value: 'guyana',
    label: 'Guyana',
  },
  {
    id: 'haiti',
    value: 'haiti',
    label: 'Haiti',
  },
  {
    id: 'heard island and mcdonald islands',
    value: 'heard island and mcdonald islands',
    label: 'Heard Island and McDonald Islands',
  },
  {
    id: 'honduras',
    value: 'honduras',
    label: 'Honduras',
  },
  {
    id: 'hong kong',
    value: 'hong kong',
    label: 'Hong Kong',
  },
  {
    id: 'hungary',
    value: 'hungary',
    label: 'Hungary',
  },
  {
    id: 'iceland',
    value: 'iceland',
    label: 'Iceland',
  },
  {
    id: 'india',
    value: 'india',
    label: 'India',
  },
  {
    id: 'indonesia',
    value: 'indonesia',
    label: 'Indonesia',
  },
  {
    id: 'iran',
    value: 'iran',
    label: 'Iran',
  },
  {
    id: 'iraq',
    value: 'iraq',
    label: 'Iraq',
  },
  {
    id: 'ireland',
    value: 'ireland',
    label: 'Ireland',
  },
  {
    id: 'isle of man',
    value: 'isle of man',
    label: 'Isle of Man',
  },
  {
    id: 'israel',
    value: 'israel',
    label: 'Israel',
  },
  {
    id: 'italy',
    value: 'italy',
    label: 'Italy',
  },
  {
    id: 'ivory coast',
    value: 'ivory coast',
    label: 'Ivory Coast',
  },
  {
    id: 'jamaica',
    value: 'jamaica',
    label: 'Jamaica',
  },
  {
    id: 'japan',
    value: 'japan',
    label: 'Japan',
  },
  {
    id: 'jersey',
    value: 'jersey',
    label: 'Jersey',
  },
  {
    id: 'jordan',
    value: 'jordan',
    label: 'Jordan',
  },
  {
    id: 'kazakhstan',
    value: 'kazakhstan',
    label: 'Kazakhstan',
  },
  {
    id: 'kenya',
    value: 'kenya',
    label: 'Kenya',
  },
  {
    id: 'kiribati',
    value: 'kiribati',
    label: 'Kiribati',
  },
  {
    id: 'kosovo',
    value: 'kosovo',
    label: 'Kosovo',
  },
  {
    id: 'kuwait',
    value: 'kuwait',
    label: 'Kuwait',
  },
  {
    id: 'kyrgyzstan',
    value: 'kyrgyzstan',
    label: 'Kyrgyzstan',
  },
  {
    id: 'laos',
    value: 'laos',
    label: 'Laos',
  },
  {
    id: 'latvia',
    value: 'latvia',
    label: 'Latvia',
  },
  {
    id: 'lebanon',
    value: 'lebanon',
    label: 'Lebanon',
  },
  {
    id: 'lesotho',
    value: 'lesotho',
    label: 'Lesotho',
  },
  {
    id: 'liberia',
    value: 'liberia',
    label: 'Liberia',
  },
  {
    id: 'libya',
    value: 'libya',
    label: 'Libya',
  },
  {
    id: 'liechtenstein',
    value: 'liechtenstein',
    label: 'Liechtenstein',
  },
  {
    id: 'lithuania',
    value: 'lithuania',
    label: 'Lithuania',
  },
  {
    id: 'luxembourg',
    value: 'luxembourg',
    label: 'Luxembourg',
  },
  {
    id: 'macao',
    value: 'macao',
    label: 'Macao',
  },
  {
    id: 'macedonia',
    value: 'macedonia',
    label: 'Macedonia',
  },
  {
    id: 'madagascar',
    value: 'madagascar',
    label: 'Madagascar',
  },
  {
    id: 'malawi',
    value: 'malawi',
    label: 'Malawi',
  },
  {
    id: 'malaysia',
    value: 'malaysia',
    label: 'Malaysia',
  },
  {
    id: 'maldives',
    value: 'maldives',
    label: 'Maldives',
  },
  {
    id: 'mali',
    value: 'mali',
    label: 'Mali',
  },
  {
    id: 'malta',
    value: 'malta',
    label: 'Malta',
  },
  {
    id: 'marshall islands',
    value: 'marshall islands',
    label: 'Marshall Islands',
  },
  {
    id: 'martinique',
    value: 'martinique',
    label: 'Martinique',
  },
  {
    id: 'mauritania',
    value: 'mauritania',
    label: 'Mauritania',
  },
  {
    id: 'mauritius',
    value: 'mauritius',
    label: 'Mauritius',
  },
  {
    id: 'mayotte',
    value: 'mayotte',
    label: 'Mayotte',
  },
  {
    id: 'mexico',
    value: 'mexico',
    label: 'Mexico',
  },
  {
    id: 'micronesia',
    value: 'micronesia',
    label: 'Micronesia',
  },
  {
    id: 'moldova',
    value: 'moldova',
    label: 'Moldova',
  },
  {
    id: 'monaco',
    value: 'monaco',
    label: 'Monaco',
  },
  {
    id: 'mongolia',
    value: 'mongolia',
    label: 'Mongolia',
  },
  {
    id: 'montenegro',
    value: 'montenegro',
    label: 'Montenegro',
  },
  {
    id: 'montserrat',
    value: 'montserrat',
    label: 'Montserrat',
  },
  {
    id: 'morocco',
    value: 'morocco',
    label: 'Morocco',
  },
  {
    id: 'mozambique',
    value: 'mozambique',
    label: 'Mozambique',
  },
  {
    id: 'myanmar',
    value: 'myanmar',
    label: 'Myanmar',
  },
  {
    id: 'namibia',
    value: 'namibia',
    label: 'Namibia',
  },
  {
    id: 'nauru',
    value: 'nauru',
    label: 'Nauru',
  },
  {
    id: 'nepal',
    value: 'nepal',
    label: 'Nepal',
  },
  {
    id: 'netherlands',
    value: 'netherlands',
    label: 'Netherlands',
  },
  {
    id: 'new caledonia',
    value: 'new caledonia',
    label: 'New Caledonia',
  },
  {
    id: 'new zealand',
    value: 'new zealand',
    label: 'New Zealand',
  },
  {
    id: 'nicaragua',
    value: 'nicaragua',
    label: 'Nicaragua',
  },
  {
    id: 'niger',
    value: 'niger',
    label: 'Niger',
  },
  {
    id: 'nigeria',
    value: 'nigeria',
    label: 'Nigeria',
  },
  {
    id: 'niue',
    value: 'niue',
    label: 'Niue',
  },
  {
    id: 'norfolk island',
    value: 'norfolk island',
    label: 'Norfolk Island',
  },
  {
    id: 'north korea',
    value: 'north korea',
    label: 'North Korea',
  },
  {
    id: 'northern mariana islands',
    value: 'northern mariana islands',
    label: 'Northern Mariana Islands',
  },
  {
    id: 'norway',
    value: 'norway',
    label: 'Norway',
  },
  {
    id: 'oman',
    value: 'oman',
    label: 'Oman',
  },
  {
    id: 'pakistan',
    value: 'pakistan',
    label: 'Pakistan',
  },
  {
    id: 'palau',
    value: 'palau',
    label: 'Palau',
  },
  {
    id: 'palestinian territory',
    value: 'palestinian territory',
    label: 'Palestinian Territory',
  },
  {
    id: 'panama',
    value: 'panama',
    label: 'Panama',
  },
  {
    id: 'papua new guinea',
    value: 'papua new guinea',
    label: 'Papua New Guinea',
  },
  {
    id: 'paraguay',
    value: 'paraguay',
    label: 'Paraguay',
  },
  {
    id: 'peru',
    value: 'peru',
    label: 'Peru',
  },
  {
    id: 'philippines',
    value: 'philippines',
    label: 'Philippines',
  },
  {
    id: 'pitcairn',
    value: 'pitcairn',
    label: 'Pitcairn',
  },
  {
    id: 'poland',
    value: 'poland',
    label: 'Poland',
  },
  {
    id: 'portugal',
    value: 'portugal',
    label: 'Portugal',
  },
  {
    id: 'puerto rico',
    value: 'puerto rico',
    label: 'Puerto Rico',
  },
  {
    id: 'qatar',
    value: 'qatar',
    label: 'Qatar',
  },
  {
    id: 'republic of the congo',
    value: 'republic of the congo',
    label: 'Republic of the Congo',
  },
  {
    id: 'reunion',
    value: 'reunion',
    label: 'Reunion',
  },
  {
    id: 'romania',
    value: 'romania',
    label: 'Romania',
  },
  {
    id: 'russia',
    value: 'russia',
    label: 'Russia',
  },
  {
    id: 'rwanda',
    value: 'rwanda',
    label: 'Rwanda',
  },
  {
    id: 'saint barthelemy',
    value: 'saint barthelemy',
    label: 'Saint Barthelemy',
  },
  {
    id: 'saint helena',
    value: 'saint helena',
    label: 'Saint Helena',
  },
  {
    id: 'saint kitts and nevis',
    value: 'saint kitts and nevis',
    label: 'Saint Kitts and Nevis',
  },
  {
    id: 'saint lucia',
    value: 'saint lucia',
    label: 'Saint Lucia',
  },
  {
    id: 'saint martin',
    value: 'saint martin',
    label: 'Saint Martin',
  },
  {
    id: 'saint pierre and miquelon',
    value: 'saint pierre and miquelon',
    label: 'Saint Pierre and Miquelon',
  },
  {
    id: 'saint vincent and the grenadines',
    value: 'saint vincent and the grenadines',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    id: 'samoa',
    value: 'samoa',
    label: 'Samoa',
  },
  {
    id: 'san marino',
    value: 'san marino',
    label: 'San Marino',
  },
  {
    id: 'sao tome and principe',
    value: 'sao tome and principe',
    label: 'Sao Tome and Principe',
  },
  {
    id: 'saudi arabia',
    value: 'saudi arabia',
    label: 'Saudi Arabia',
  },
  {
    id: 'senegal',
    value: 'senegal',
    label: 'Senegal',
  },
  {
    id: 'serbia',
    value: 'serbia',
    label: 'Serbia',
  },
  {
    id: 'seychelles',
    value: 'seychelles',
    label: 'Seychelles',
  },
  {
    id: 'sierra leone',
    value: 'sierra leone',
    label: 'Sierra Leone',
  },
  {
    id: 'singapore',
    value: 'singapore',
    label: 'Singapore',
  },
  {
    id: 'sint maarten',
    value: 'sint maarten',
    label: 'Sint Maarten',
  },
  {
    id: 'slovakia',
    value: 'slovakia',
    label: 'Slovakia',
  },
  {
    id: 'slovenia',
    value: 'slovenia',
    label: 'Slovenia',
  },
  {
    id: 'solomon islands',
    value: 'solomon islands',
    label: 'Solomon Islands',
  },
  {
    id: 'somalia',
    value: 'somalia',
    label: 'Somalia',
  },
  {
    id: 'south africa',
    value: 'south africa',
    label: 'South Africa',
  },
  {
    id: 'south georgia and the south sandwich islands',
    value: 'south georgia and the south sandwich islands',
    label: 'South Georgia and the South Sandwich Islands',
  },
  {
    id: 'south korea',
    value: 'south korea',
    label: 'South Korea',
  },
  {
    id: 'south sudan',
    value: 'south sudan',
    label: 'South Sudan',
  },
  {
    id: 'spain',
    value: 'spain',
    label: 'Spain',
  },
  {
    id: 'sri lanka',
    value: 'sri lanka',
    label: 'Sri Lanka',
  },
  {
    id: 'sudan',
    value: 'sudan',
    label: 'Sudan',
  },
  {
    id: 'suriname',
    value: 'suriname',
    label: 'Suriname',
  },
  {
    id: 'svalbard and jan mayen',
    value: 'svalbard and jan mayen',
    label: 'Svalbard and Jan Mayen',
  },
  {
    id: 'swaziland',
    value: 'swaziland',
    label: 'Swaziland',
  },
  {
    id: 'sweden',
    value: 'sweden',
    label: 'Sweden',
  },
  {
    id: 'switzerland',
    value: 'switzerland',
    label: 'Switzerland',
  },
  {
    id: 'syria',
    value: 'syria',
    label: 'Syria',
  },
  {
    id: 'taiwan',
    value: 'taiwan',
    label: 'Taiwan',
  },
  {
    id: 'tajikistan',
    value: 'tajikistan',
    label: 'Tajikistan',
  },
  {
    id: 'tanzania',
    value: 'tanzania',
    label: 'Tanzania',
  },
  {
    id: 'thailand',
    value: 'thailand',
    label: 'Thailand',
  },
  {
    id: 'togo',
    value: 'togo',
    label: 'Togo',
  },
  {
    id: 'tokelau',
    value: 'tokelau',
    label: 'Tokelau',
  },
  {
    id: 'tonga',
    value: 'tonga',
    label: 'Tonga',
  },
  {
    id: 'trinidad and tobago',
    value: 'trinidad and tobago',
    label: 'Trinidad and Tobago',
  },
  {
    id: 'tunisia',
    value: 'tunisia',
    label: 'Tunisia',
  },
  {
    id: 'turkey',
    value: 'turkey',
    label: 'Turkey',
  },
  {
    id: 'turkmenistan',
    value: 'turkmenistan',
    label: 'Turkmenistan',
  },
  {
    id: 'turks and caicos islands',
    value: 'turks and caicos islands',
    label: 'Turks and Caicos Islands',
  },
  {
    id: 'tuvalu',
    value: 'tuvalu',
    label: 'Tuvalu',
  },
  {
    id: 'u.s. virgin islands',
    value: 'u.s. virgin islands',
    label: 'U.S. Virgin Islands',
  },
  {
    id: 'uganda',
    value: 'uganda',
    label: 'Uganda',
  },
  {
    id: 'ukraine',
    value: 'ukraine',
    label: 'Ukraine',
  },
  {
    id: 'united arab emirates',
    value: 'united arab emirates',
    label: 'United Arab Emirates',
  },
  {
    id: 'united kingdom',
    value: 'united kingdom',
    label: 'United Kingdom',
  },
  {
    id: 'united states',
    value: 'united states',
    label: 'United States',
  },
  {
    id: 'united states minor outlying islands',
    value: 'united states minor outlying islands',
    label: 'United States Minor Outlying Islands',
  },
  {
    id: 'uruguay',
    value: 'uruguay',
    label: 'Uruguay',
  },
  {
    id: 'uzbekistan',
    value: 'uzbekistan',
    label: 'Uzbekistan',
  },
  {
    id: 'vanuatu',
    value: 'vanuatu',
    label: 'Vanuatu',
  },
  {
    id: 'vatican',
    value: 'vatican',
    label: 'Vatican',
  },
  {
    id: 'venezuela',
    value: 'venezuela',
    label: 'Venezuela',
  },
  {
    id: 'vietnam',
    value: 'vietnam',
    label: 'Vietnam',
  },
  {
    id: 'wallis and futuna',
    value: 'wallis and futuna',
    label: 'Wallis and Futuna',
  },
  {
    id: 'western sahara',
    value: 'western sahara',
    label: 'Western Sahara',
  },
  {
    id: 'yemen',
    value: 'yemen',
    label: 'Yemen',
  },
  {
    id: 'zambia',
    value: 'zambia',
    label: 'Zambia',
  },
  {
    id: 'zimbabwe',
    value: 'zimbabwe',
    label: 'Zimbabwe',
  },
];
